import { Module } from 'vuex';
import { IField } from '@/fields/types/field';
import { RootState } from '@/store/store';
import { actions } from '@/fields/store/field.actions';
import { mutations } from '@/fields/store/field.mutations';
import { getters } from '@/fields/store/field.getters';
import { ISelectedPageFieldIds } from '@/fields/types/selected-page-field-ids';

export const namespace: string = 'fields';
const namespaced: boolean = true;

export interface IFieldState {
  loading: boolean;
  documentId: string;
  fields: IField[];
  selectedPageFieldIds: ISelectedPageFieldIds;
  markedPageFieldIds: ISelectedPageFieldIds;
  inEditMode: boolean;
  pageWidth: number;
  focusedFieldId: string;
  tabFieldId: string;
  senderSignature: string;
  lastUpdatedFieldId: string;
}

export const state: IFieldState = {
  loading: false,
  documentId: null,
  fields: [],
  selectedPageFieldIds: { pageId: null, fieldIds: [] },
  markedPageFieldIds: { pageId: null, fieldIds: [] },
  inEditMode: false,
  pageWidth: null,
  focusedFieldId: null,
  tabFieldId: null,
  senderSignature: '',
  lastUpdatedFieldId: null,
};

export const fields: Module<IFieldState, RootState> = {
  state,
  namespaced,
  actions,
  mutations,
  getters,
};
